<div class="modal-header">
  @if (supplierModel != null) {
    <h4 class="modal-title">View Supplier {{supplierModel.supplierDetails?.supplierId}}</h4>
  }
</div>
<div class="modal-body">
  <div>
    <fieldset class="border p-2" style="margin-top: 10px;">
      <legend class="float-none w-auto legend-style"><span style="margin-left: 5px; margin-right: 5px;">Supplier details</span></legend>

      @if (supplierModel != null) {
        <div>
          <!-- Basic Information -->
          <div class="row mb5">
            <div class="col-sm-3">
              <label><b>Supplier ID:</b></label>
            </div>
            <div class="col-sm-3">
              <label>{{supplierModel.supplierDetails?.supplierId}}</label>
            </div>
            <div class="col-sm-3">
              <label><b>Supplier name:</b></label>
            </div>
            <div class="col-sm-3">
              <label>{{supplierModel.supplierDetails?.supplierName}}</label>
            </div>
          </div>
          <div class="row mb5">
            <div class="col-sm-3">
              <label><b>Site ID:</b></label>
            </div>
            <div class="col-sm-3">
              <label>{{supplierModel.supplierDetails?.siteId}}</label>
            </div>
            <div class="col-sm-3">
              <label><b>Legal entity:</b></label>
            </div>
            <div class="col-sm-3">
              <label>{{supplierModel.supplierDetails?.legalEntity}}</label>
            </div>
          </div>
          <div class="row mb5">
            <div class="col-sm-3">
              <label><b>Legal entity name:</b></label>
            </div>
            <div class="col-sm-3">
              <label>{{supplierModel.supplierDetails?.legalEntityName}}</label>
            </div>
            <div class="col-sm-3">
              <label><b>Supplier item identification:</b></label>
            </div>
            <div class="col-sm-3">
              <label>{{supplierModel.supplierDetails?.supplierItemIdentification}}</label>
            </div>
          </div>
          <!-- Country and Status Information -->
          <div class="row mb5">
            <div class="col-sm-3">
              <label><b>Country of origin code:</b></label>
            </div>
            <div class="col-sm-3">
              <label>{{supplierModel.supplierDetails?.countryOfOriginCode}}</label>
            </div>
            <div class="col-sm-3">
              <label><b>Country of origin name:</b></label>
            </div>
            <div class="col-sm-3">
              <label>{{supplierModel.supplierDetails?.countryOfOriginName}}</label>
            </div>
          </div>
          <div class="row mb5">
            <div class="col-sm-3">
              <label><b>Stock status:</b></label>
            </div>
            <div class="col-sm-3">
              <label>{{supplierModel.supplierDetails?.stockCode}}</label>
            </div>
            <div class="col-sm-3">
              <label><b>Stock status description:</b></label>
            </div>
            <div class="col-sm-3">
              <label>{{supplierModel.supplierDetails?.stockCodeDescription}}</label>
            </div>
          </div>
          <div class="row mb5">
            <div class="col-sm-3">
              <label><b>Customs statistical code:</b></label>
            </div>
            <div class="col-sm-3">
              <label>{{supplierModel.supplierDetails?.customsStatisticalCode}}</label>
            </div>
            <div class="col-sm-3">
              <label><b>Base UOM code:</b></label>
            </div>
            <div class="col-sm-3">
              <label>{{supplierModel.supplierDetails?.baseUOMCode}}</label>
            </div>
          </div>
          <!-- Lead Time Information -->
          <div class="row mb5">
            <div class="col-sm-3">
              <label><b>Lead time duration:</b></label>
            </div>
            <div class="col-sm-3">
              <label>{{supplierModel.leadtimes?.leadTimeDuration}}</label>
            </div>
            <div class="col-sm-3">
              <label><b>Lead time duration end:</b></label>
            </div>
            <div class="col-sm-3">
              <label>{{supplierModel.leadtimes?.leadTimeDurationEnd}}</label>
            </div>
          </div>
          <div class="row mb5">
            <div class="col-sm-3">
              <label><b>Max lead time duration:</b></label>
            </div>
            <div class="col-sm-3">
              <label>{{supplierModel.leadtimes?.maxLeadTimeDuration}}</label>
            </div>
            <div class="col-sm-3">
              <label><b>Max lead time duration end:</b></label>
            </div>
            <div class="col-sm-3">
              <label>{{supplierModel.leadtimes?.maxLeadTimeDurationEnd}}</label>
            </div>
          </div>
          <div class="row mb5">
            <div class="col-sm-3">
              <label><b>Leadtime quantity limit:</b></label>
            </div>
            <div class="col-sm-3">
              <label>{{supplierModel.leadtimes?.leadtimeQuantityLimit}}</label>
            </div>
            <div class="col-sm-3">
            </div>
            <div class="col-sm-3">
            </div>
          </div>
          <!-- Hazardous Goods Information -->
          <div class="row mb5">
            <div class="col-sm-3">
              <label><b>Is dangerous goods:</b></label>
            </div>
            <div class="col-sm-3">
              <label></label>
            </div>
            <div class="col-sm-3">
              <label><b>Hazardous class:</b></label>
            </div>
            <div class="col-sm-3">
              <label>{{supplierModel.hazardousMaterial?.hazardousClass}}</label>
            </div>
          </div>
          <div class="row mb5">
            <div class="col-sm-3">
              <label><b>Hazardous class description:</b></label>
            </div>
            <div class="col-sm-3">
              <label>{{supplierModel.hazardousMaterial?.hazardousClassDescription}}</label>
            </div>
            <div class="col-sm-3">
            </div>
            <div class="col-sm-3">
            </div>
          </div>
          <!-- Dimensions Information -->
          <div class="row mb5">
            <div class="col-sm-3">
              <label><b>Dimension description:</b></label>
            </div>
            <div class="col-sm-3">
              <label>{{supplierModel.dimensions?.dimensionDescription}}</label>
            </div>
            <div class="col-sm-3">
              <label><b>Dimension UoM:</b></label>
            </div>
            <div class="col-sm-3">
              <label>{{supplierModel.dimensions?.dimensionUoM}}</label>
            </div>
          </div>
          <div class="row mb5">
            <div class="col-sm-3">
              <label><b>Length:</b></label>
            </div>
            <div class="col-sm-3">
              <label>{{supplierModel.dimensions?.length | number:'1.3-3'}}</label>
            </div>
            <div class="col-sm-3">
              <label><b>Width:</b></label>
            </div>
            <div class="col-sm-3">
              <label>{{supplierModel.dimensions?.width | number:'1.3-3'}}</label>
            </div>
          </div>
          <div class="row mb5">
            <div class="col-sm-3">
              <label><b>Height:</b></label>
            </div>
            <div class="col-sm-3">
              <label>{{supplierModel.dimensions?.height | number:'1.3-3'}}</label>
            </div>
            <div class="col-sm-3">
            </div>
            <div class="col-sm-3">
            </div>
          </div>
          <!-- Weight Information -->
          <div class="row mb5">
            <div class="col-sm-3">
              <label><b>Net weight:</b></label>
            </div>
            <div class="col-sm-3">
              <label>{{supplierModel.dimensions?.netWeight | number:'1.3-3'}}</label>
            </div>
            <div class="col-sm-3">
              <label><b>Gross weight:</b></label>
            </div>
            <div class="col-sm-3">
              <label>{{supplierModel.dimensions?.grossWeight | number:'1.3-3'}}</label>
            </div>
          </div>
          <div class="row mb5">
            <div class="col-sm-3">
              <label><b>Weight UoM:</b></label>
            </div>
            <div class="col-sm-3">
              <label>{{supplierModel.dimensions?.weightUoM}}</label>
            </div>
            <div class="col-sm-3">
            </div>
            <div class="col-sm-3">
            </div>
          </div>
          <!-- Volume Information -->
          <div class="row mb5">
            <div class="col-sm-3">
              <label><b>Volume:</b></label>
            </div>
            <div class="col-sm-3">
              <label>{{supplierModel.dimensions?.volume | number:'1.3-3'}}</label>
            </div>
            <div class="col-sm-3">
              <label><b>Net volume:</b></label>
            </div>
            <div class="col-sm-3">
              <label>{{supplierModel.dimensions?.netVolume | number:'1.3-3'}}</label>
            </div>
          </div>
          <div class="row mb5">
            <div class="col-sm-3">
              <label><b>Gross volume:</b></label>
            </div>
            <div class="col-sm-3">
              <label>{{supplierModel.dimensions?.grossVolume | number:'1.3-3'}}</label>
            </div>
            <div class="col-sm-3">
              <label><b>Volume UoM:</b></label>
            </div>
            <div class="col-sm-3">
              <label>{{supplierModel.dimensions?.volumeUoM}}</label>
            </div>
          </div>
          <!-- Boolean Flags -->
          <div class="row mb5">
            <div class="col-sm-3">
              <label><b>Is main supplier:</b></label>
            </div>
            <div class="col-sm-3">
              <label>{{supplierModel.supplierDetails?.isMainSupplier ? 'Yes' : 'No'}}</label>
            </div>
            <div class="col-sm-3">
              <label><b>Is external:</b></label>
            </div>
            <div class="col-sm-3">
              <label>{{supplierModel.supplierDetails?.isExternal ? 'Yes' : 'No'}}</label>
            </div>
          </div>
          <!-- Boolean Flags -->
          <div class="row mb5">
            <div class="col-sm-3">
              <label><b>Is core item owner:</b></label>
            </div>
            <div class="col-sm-3">
              <label>{{supplierModel.supplierDetails?.isCoreItemOwner ? 'Yes' : 'No'}}</label>
            </div>
            <div class="col-sm-3">
            </div>
            <div class="col-sm-3">
            </div>
          </div>
          <!-- Date Time Information -->
          <div class="row mb5">
            <div class="col-sm-3">
              <label><b>Created date:</b></label>
            </div>
            <div class="col-sm-3">
              <label>{{supplierModel.timestamps?.createdDateTime | date: 'yyyy-MM-dd HH:mm:ss'}}</label>
            </div>
            <div class="col-sm-3">
              <label><b>Update date:</b></label>
            </div>
            <div class="col-sm-3">
              <label>{{supplierModel.timestamps?.updateDateTime | date: 'yyyy-MM-dd HH:mm:ss'}}</label>
            </div>
          </div>
          <div class="row mb5">
            <div class="col-sm-3">
              <label><b>Supplier created date:</b></label>
            </div>
            <div class="col-sm-3">
              <label>{{supplierModel.timestamps?.supplierCreatedDateTime | date: 'yyyy-MM-dd HH:mm:ss'}}</label>
            </div>
            <div class="col-sm-3">
              <label><b>Last modification date:</b></label>
            </div>
            <div class="col-sm-3">
              <label>{{supplierModel.timestamps?.lastModificationDateTime | date: 'yyyy-MM-dd HH:mm:ss'}}</label>
            </div>
          </div>
          <div class="row mb5">
            <div class="col-sm-3">
              <label><b>Original source publish time:</b></label>
            </div>
            <div class="col-sm-3">
              <label>{{supplierModel.timestamps?.originalSourcePublishTime | date: 'yyyy-MM-dd HH:mm:ss'}}</label>
            </div>
            <div class="col-sm-3">
            </div>
            <div class="col-sm-3">
            </div>
          </div>
        </div>
      }
    </fieldset>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-dark" (click)="close()">Close</button>
</div>
